import Repository from '../Repository';

const url = '/locker-room';

export default {
    getAFORM() {
        return Repository.get(`${url}/get-aform`, {localLoading: true});
    },
    sendContactForm(payload) {
        return Repository.post(`${url}/contact`, payload, {localLoading: true});
    },


    getPersonalNotes() {
        return Repository.get(`${url}/notes`, {localLoading: true});
    },

    setPersonalNotes(notes) {
        return Repository.post(`${url}/notes`, {notes: notes}, {localLoading: true});
    },

}
